<!-- DeleteConfirmationDialog.vue -->
<template>
  <v-dialog v-model="dialogVisible" max-width="400px" @keydown.stop.esc="closeDialog">
    <v-card class="pa-4">
      <v-card-title class="pa-0 ma-0">
        <span class="text-h5">{{ title }}</span>
      </v-card-title>
      <v-card-text class="pa-0 mt-6">{{ text }}</v-card-text>
      <div v-if="confirmText" class="mt-2 mb-2 d-flex align-start gap-x-3">
        <v-icon size="22" >mdi-alert</v-icon>
        <v-card-text class="pa-0"><i>To confirm the deletion, enter the name in the text input field.</i></v-card-text>
      </div>
      <v-text-field v-if="confirmText" v-model="confirmationInput" small variant="outlined" :placeholder="confirmText" density="compact" clearable></v-text-field>
      <v-card-actions :class="`pa-0 justify-end ${confirmText ? 'mt-0' : 'mt-3'}`">
        <v-btn
          size="large"
          variant="outlined"
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          size="large"
          variant="flat"
          color="primary"
          :loading="loading"
          @click="confirmDelete"
          ref="deleteButton"
          :disabled="confirmText != '' && confirmationInput !== confirmText"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteConfirmationDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: 'Deletion Confirmation'
    },
    text: {
      type: String,
      default: 'Are you sure you want to delete the item?'
    },
    onDelete: {
      type: Function
    },
    confirmText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      confirmationInput: ''
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    closeDialog () {
      this.dialogVisible = false
    },
    async confirmDelete () {
      this.loading = true
      try {
        await this.onDelete()
        this.closeDialog()
      } catch (error) {
        console.error('Delete operation failed:', error)
        // You might want to show an error message to the user here
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.gap-x-3 {
  column-gap: 8px;
}
</style>
